import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import styled from 'styled-components';
import Colors from '@components/shared/Colors';
import { TextVariant, Typography } from '@components/shared/design/Typography';
import TextLink from '@components/shared/TextLink';
import TextLinkButton from '@components/shared/TextLinkButton';

interface ProductBuyOptionHeadingProps {
  textKey: string;
  link?: string;
  linkText?: string;
  onClick?: () => void;
  buttonText?: string;
  marginBottom?: string;
}

const ProductBuyOptionHeading: React.FC<ProductBuyOptionHeadingProps> = ({ textKey, link, linkText, onClick, buttonText, marginBottom }) => {
  const { t } = useTranslation();

  return (
    <Wrapper $marginBottom={marginBottom}>
      <Typography $variant={TextVariant.UpperText5}>{t(textKey)}</Typography>
      {link && (
        <StyledTextLink $color={Colors.lilac} to={link}>
          {t(linkText || 'components.help-me-choose')}
        </StyledTextLink>
      )}
      {onClick && (
        <StyledTextLinkButton $color={Colors.lilac} onClick={onClick}>
          {t(buttonText || 'components.help-me-choose')}
        </StyledTextLinkButton>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div<{ $marginBottom?: string }>`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${({ $marginBottom }) => $marginBottom || '15px'};
`;

const StyledTextLink = styled(TextLink)`
  margin-left: 10px;
  font-size: 12px;
`;

const StyledTextLinkButton = styled(TextLinkButton)`
  margin-left: 10px;
  font-size: 12px;
`;

export default ProductBuyOptionHeading;
